'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TheScoreArticleSponsor = require('./TheScoreArticleSponsor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TheScoreArticleSponsor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }